import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
export function TargetAudience() {
  return <section className="py-16 px-4 bg-slate-50 border-y border-slate-200" data-id="element-246">
      <div className="max-w-5xl mx-auto" data-id="element-247">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-248">
          {/* Who this is for */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-teal-500" data-id="element-249">
            <h3 className="text-2xl font-bold text-slate-900 mb-6 flex items-center gap-3" data-id="element-250">
              <CheckCircle2 className="w-8 h-8 text-teal-500" data-id="element-251" />
              Para quién es esto
            </h3>
            <ul className="space-y-4" data-id="element-252">
              <li className="flex gap-3 items-start" data-id="element-253">
                <CheckCircle2 className="w-5 h-5 text-teal-500 flex-shrink-0 mt-0.5" data-id="element-254" />
                <span className="text-slate-700" data-id="element-255">
                  Madres con hijos en edad escolar (Pre-K a Middle School).
                </span>
              </li>
              <li className="flex gap-3 items-start" data-id="element-256">
                <CheckCircle2 className="w-5 h-5 text-teal-500 flex-shrink-0 mt-0.5" data-id="element-257" />
                <span className="text-slate-700" data-id="element-258">
                  Familias que han intentado shampoos de farmacia sin resultados
                  permanentes.
                </span>
              </li>
              <li className="flex gap-3 items-start" data-id="element-259">
                <CheckCircle2 className="w-5 h-5 text-teal-500 flex-shrink-0 mt-0.5" data-id="element-260" />
                <span className="text-slate-700" data-id="element-261">
                  Mamás que buscan una solución sin químicos agresivos o
                  tóxicos.
                </span>
              </li>
              <li className="flex gap-3 items-start" data-id="element-262">
                <CheckCircle2 className="w-5 h-5 text-teal-500 flex-shrink-0 mt-0.5" data-id="element-263" />
                <span className="text-slate-700" data-id="element-264">
                  Personas que necesitan eliminar el problema hoy mismo antes de
                  que la escuela lo note.
                </span>
              </li>
            </ul>
          </div>

          {/* Who this is NOT for */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-red-500" data-id="element-265">
            <h3 className="text-2xl font-bold text-slate-900 mb-6 flex items-center gap-3" data-id="element-266">
              <XCircle className="w-8 h-8 text-red-500" data-id="element-267" />
              Para quién NO es
            </h3>
            <ul className="space-y-4" data-id="element-268">
              <li className="flex gap-3 items-start" data-id="element-269">
                <XCircle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-270" />
                <span className="text-slate-700" data-id="element-271">
                  Personas que buscan una solución de "5 minutos" sin peinar.
                </span>
              </li>
              <li className="flex gap-3 items-start" data-id="element-272">
                <XCircle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-273" />
                <span className="text-slate-700" data-id="element-274">
                  Quienes prefieren seguir gastando $30 por cada caja de shampoo
                  de farmacia.
                </span>
              </li>
              <li className="flex gap-3 items-start" data-id="element-275">
                <XCircle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-276" />
                <span className="text-slate-700" data-id="element-277">
                  Quienes no están dispuestos a seguir un calendario de 7 días.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}